import { Channel, DialogType, Topic } from "../../constants";
import { ExternalUtils, GeneralUtils, MessageBrokerUtils } from "../../utils";
import React, { useCallback, useMemo } from "react";
import { UISelectors } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";

import { LocalizationMessages } from "../../localization/messages";
import { PanicApi } from "../../redux/api";
import PanicTooltipCloseButton from "./PanicTooltipCloseButton";
import PropTypes from "prop-types";
import { UIActionCreators } from "../../redux/action-creators";
import classNames from "classnames";
import { useIntl } from "react-intl";

export const PanicTooltip = ({ isMobile }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const panicTooltipClosed = useSelector(UISelectors.panicTooltipClosed);

  const closePanicTooltip = useCallback(
    data => dispatch(UIActionCreators.closePanicTooltip(data)),
    [dispatch]
  );

  const handleClick = async () => {
    closePanicTooltip(true);

    if (typeof window.triple8Messaging !== "undefined")
      window.triple8Messaging.logOut();

    const requestData = {
      TimezoneOffset: GeneralUtils.getTimezoneOffset()
    };

    PanicApi.panic(requestData).finally(() => {
      const preLogoutSubscription = MessageBrokerUtils.subscribe({
        channel: Channel.IDENTITY,
        topic: Topic.preLogoutSuccess,
        callback: () => {
          const currentTime = new Date();
          MessageBrokerUtils.publish({
            channel: Channel.UI,
            topic: Topic.Dialog,
            headers: {
              publisher: "UAA"
            },
            data: {
              dialogType: DialogType.Panic,
              options: {
                endOfBreak: `${`0${currentTime.getHours()}`.slice(
                  -2
                )}:${`0${currentTime.getMinutes()}`.slice(-2)}`
              }
            }
          });
          preLogoutSubscription?.unsubscribe();
        }
      });

      ExternalUtils.ClientsFrameworkService.Logout.doLogoutWithoutRefreshAsync(
        ""
      );
    });
  };

  const messages = {
    button: LocalizationMessages.panicMessageButton,
    content: LocalizationMessages.panicMessageContent,
    link: LocalizationMessages.panicMessageLink
  };

  const panicTooltipClasses = useMemo(
    () => classNames("tooltip", "tooltip-hide"),
    []
  );

  return (
    <div className={panicTooltipClosed ? panicTooltipClasses : "tooltip"}>
      {formatMessage(messages.content)}
      <button onClick={handleClick}>{formatMessage(messages.link)}</button>
      {isMobile && <PanicTooltipCloseButton />}
    </div>
  );
};

PanicTooltip.propTypes = {
  isMobile: PropTypes.bool
};

export default React.memo(PanicTooltip);
